export default "__VITE_ASSET__Dxojg0Zs__"